<template>
  <div id="content" class="bg-light pb-5">
    <progressbar progress="2%"
                 :image-url="vehicleImage">
    </progressbar>

    <!-- Mobile -->
    <section class="d-block d-md-none bg-white pt-0">
        <div class="row no-gutters">
            <div class="col-4">
                <form method="post" :action="amagUrl" class="go-back-form">
                    <input type="hidden" name="_token" :value="csrfToken">
                    <input type="hidden" name="identifier" :value="identifier">
                    <button type="submit" dusk="submit" class="btn btn-outline-primary btn-block py-2">
                        {{$t('vue.checkout.checkoutLoginRegister.back')}}
                    </button>
                </form>
            </div>
            <div class="col-4">
            <button class="btn btn-default btn-block collapse-button py-2"
                    :class="showRegister ? 'active' : ''"
                    type="button"
                    id="collapse-show-register-button"
                    dusk="checkout_login_register_mobile_toggle_new_customer"
                    @click="toggleRegister">
                {{$t('vue.checkout.checkoutLoginRegister.new')}}
            </button>
        </div>

        <div class="col-4">
            <button class="btn btn-default btn-block collapse-button py-2"
                    :class="!showRegister ? 'active' : ''"
                    type="button"
                    id="collapse-show-login-button"
                    dusk="checkout_login_register_mobile_toggle_existing_customer"
                    @click="toggleLogin">
                {{$t('vue.checkout.checkoutLoginRegister.registered')}}
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div v-if="showRegister" class="p-3" id="collapseRegister">
            <register
                :new-customer-url="newCustomerUrl"
                wrapper-class="text-center"
                text-classes="text-center"
            ></register>
          </div>

          <div v-else class="p-3" id="collapseLogin">
            <login-form
                :csrf-token="csrfToken"
                :login-url="loginUrl"
                :password-reset-url="passwordResetUrl"
                identifier="identifier"
                :has-login-error="hasLoginError"
                :login-error="loginErrorMessage"
            ></login-form>
          </div>
        </div>
      </div>
    </section>

    <!-- Desktop -->
    <section class="container bg-white my-5 p-5 d-none d-md-block">
      <div class="row justify-content-center align-items-top">
        <div class="col-12">
          <form method="post" :action="amagUrl">
            <input type="hidden" name="_token" :value="csrfToken">
            <input type="hidden" name="identifier" :value="identifier">
            <button type="submit" dusk="submit" class="btn btn-outline-primary"
                    @click="goBackToAmagWebsite">
                {{$t('vue.checkout.checkoutLoginRegister.back')}}
            </button>
          </form>

          <div class="container-fluid d-none d-sm-block">

            <div class="row">
              <div class="col-5">
                <register
                    :new-customer-url="newCustomerUrl"
                ></register>
              </div>

              <div class="col-5 offset-2">
                <login-form
                    :csrf-token="csrfToken"
                    :login-url="loginUrl"
                    dusk="existing-costumer"
                    :password-reset-url="passwordResetUrl"
                    identifier="identifier"
                    :has-login-error="hasLoginError"
                    :login-error="loginErrorMessage"
                ></login-form>
              </div>

            </div>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "CheckoutLoginRegister",
  props: {
    loginError: {
      type: String,
      required: false,
      default: ""
    },
    amagUrl: {
      type: String,
      required: true
    },
    loginUrl: {
      type: String,
      required: true
    },
    newCustomerUrl: {
      type: String,
      required: true
    },
    passwordResetUrl: {
      type: String,
      required: true
    },
    csrfToken: {
      type: String,
      required: true
    },
    identifier: {
      type: String,
      required: true
    },
    belongsToCheckout: {
      type: Boolean,
      required: false,
      default: false
    },
    vehicleImage: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      passwordFieldType: 'password',
      buttons: {
        collapseRegister: {
          classes: "active"
        },
        collapseLogin: {
          classes: ""
        }
      },
      showRegister: true
    }
  },
  methods: {
    toggleRegister () {
      this.showRegister = true;
    },
    toggleLogin () {
      this.showRegister = false;
    },
    goBackToAmagWebsite () {

    }
  },

  computed: {
    hasLoginError () {
      return this.loginError.length > 0
    },
    loginErrorMessage () {
      return this.loginError
    }
  },
  mounted () {
    if (this.hasLoginError){
      this.toggleLogin()
    } else {
      this.toggleRegister()
    }
  }
}
</script>

<style scoped lang="scss">
.collapse-button {
  background: #B1B1B1;
  color: #1B2638;

  &.active {
    background: #1B2638;
    color: #FFFFFF;
  }
}
.go-back-form {
  height: 100%
}
button {
  height: 100%
}
</style>
